import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { TimeFormat, User } from '@app/core/_models'
import { SelectedSession, SelectedSessionService, UtilsService } from '@app/core/_services'
import { ContentStackService } from '@app/core/_services/content-stack.service'
import { EpochToTimePipe } from '@app/core/pipes/epoch-to-time.pipe'
import { SessionIndicatorIconsComponent } from '@app/routes/dashboard/components/session-indicator-icons/session-indicator-icons.component'
import { ButtonModule } from 'primeng/button'

@Component({
    selector: 'fm-selected-sessions-list-item',
    imports: [SessionIndicatorIconsComponent, EpochToTimePipe, ButtonModule],
    templateUrl: './selected-sessions-list-item.component.html',
    styleUrl: './selected-sessions-list-item.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectedSessionsListItemComponent {
    @Input() sessionInfo: SelectedSession
    @Input() user: User
    //@Input() width: number
    // @Input() timezone: string
    //@Input() timeFormat: TimeFormat = '12hr'
    //@Input() height: number | null = null

    //public tileHeight: number = 0
    public timeString: string
    public partnerNameOrStatusString: string
    //public isLockedIn: boolean
    //public tileSize: TileSize
    public displayTimeFormat: string

    //public cancelConfirmState: boolean = false

    // private sessionDimensionsMap: { [key: number]: BookedSessionDimensions } = {
    // 	[SESSION_DURATION_25_MINS]: {
    // 		tileHeight: TIMESLOT_HEIGHT * 2 - 4,
    // 	},
    // 	[SESSION_DURATION_50_MINS]: {
    // 		tileHeight: TIMESLOT_HEIGHT * 4 - 4,
    // 	},
    // 	[SESSION_DURATION_75_MINS]: {
    // 		tileHeight: TIMESLOT_HEIGHT * 6 - 4,
    // 	},
    // }

    //public joinButtonEnabled: boolean = false
    //public joinButtonAvailable: boolean = false
    //public SessionTileSource = SessionTileSource

    constructor(
        private utilsService: UtilsService,
        private contentStackService: ContentStackService,
        private selectedSessionService: SelectedSessionService,
    ) {}

    ngOnInit() {
        // this.updateTileSizeBasedOnWidth()
        // this.setTileHeight()
        this.setTimeDisplayStringFormat()
        // this.setPartnerNameOrStatusString()
        // this.updateJoinButtonStatus()
        // this.setLockedInState()
    }
    ngOnChanges(e) {
        // this.updateTileSizeBasedOnWidth()
        // this.setTileHeight()
        this.setTimeDisplayStringFormat()
        // this.setPartnerNameOrStatusString()
        // this.updateJoinButtonStatus()
        // this.setLockedInState()
    }

    private setTimeDisplayStringFormat(): void {
        const timeFormat = this.user.settings?.timeFormat ?? '12hr'
        if (timeFormat == '12hr') {
            this.displayTimeFormat = 'h:mma'
        } else {
            this.displayTimeFormat = 'HH:mm'
        }
    }

    onClickRemoveSession(): void {
        this.selectedSessionService.deleteSelectedSession(this.sessionInfo.sessionTime)
    }

    // private updateTileSizeBasedOnWidth(): void {
    // 	if (this.width >= 154) {
    // 		this.tileSize = 'xlarge'
    // 	} else if (this.width > 117) {
    // 		this.tileSize = 'large'
    // 	} else if (this.width > 101) {
    // 		this.tileSize = 'medium'
    // 	} else if (this.width > 89) {
    // 		this.tileSize = 'small'
    // 	} else {
    // 		this.tileSize = 'xsmall'
    // 	}
    // }

    // private setLockedInState(): void {
    // 	this.isLockedIn = this.sessionStateService.isLockedInState(this.sessionInfo.state)
    // }

    // private setTileHeight(): void {
    // 	if (this.height) {
    // 		// Upcoming sessions and My Schedule will have set height
    // 		// regardless of duration
    // 		// NOTE: As we build this out, consider creating a seperate component
    // 		// specific to My Schedule and Upcoming sessions instead of re-using
    // 		// calendar tile component
    // 		this.tileHeight = this.height
    // 	} else {
    // 		if (this.sessionInfo) {
    // 			const duration = this.sessionInfo.duration
    // 			if (duration === SESSION_DURATION_75_MINS && this.slotNumber > 93) {
    // 				this.tileHeight = this.sessionDimensionsMap[SESSION_DURATION_50_MINS].tileHeight
    // 			} else {
    // 				this.tileHeight = this.sessionDimensionsMap[duration].tileHeight
    // 			}
    // 		}
    // 	}
    // }

    // private setPartnerNameOrStatusString(): void {
    // 	const state = this.sessionInfo.state
    // 	const currentTime = this.utilsService.getCurrentTimestamp()

    // 	if (this.sessionStateService.isMatchedState(state)) {
    // 		this.partnerNameOrStatusString = this.sessionInfo.partnerDisplayName
    // 	} else if (state == SESSION_STATE_SEARCHING) {
    // 		this.partnerNameOrStatusString = 'Searching...'
    // 	} else if (state == SESSION_STATE_LATE) {
    // 		this.partnerNameOrStatusString = 'Late'
    // 	} else if (state == SESSION_STATE_PENDING || state == SESSION_STATE_LOST_PARTNER) {
    // 		if (this.utilsService.hasSessionTimePassed(this.sessionInfo.sessionTime, currentTime)) {
    // 			this.partnerNameOrStatusString = 'Join to match'
    // 		} else {
    // 			this.partnerNameOrStatusString = 'Matching...'
    // 		}
    // 	} else {
    // 		this.partnerNameOrStatusString = ''
    // 	}
    // }

    // private updateJoinButtonStatus(): void {
    // 	//this.routerLink = '/session/' + (this.sessionInfo.sessionTime / 1000).toString()
    // 	const state = this.sessionInfo.state
    // 	const currentTime = this.utilsService.getCurrentTimestamp()
    // 	let rematchAtStart = false
    // 	this.joinButtonEnabled = this.utilsService.showVideoIcon(
    // 		this.sessionInfo.sessionTime,
    // 		this.sessionInfo.duration,
    // 	)
    // 	if (this.sessionStateService.isMatchedState(state)) {
    // 		this.joinButtonAvailable = true
    // 	} else if (state == SESSION_STATE_SEARCHING) {
    // 		this.joinButtonAvailable = true
    // 	} else if (state == SESSION_STATE_LATE) {
    // 		this.joinButtonAvailable = true
    // 	} else if (
    // 		(state == SESSION_STATE_PENDING || state == SESSION_STATE_LOST_PARTNER) &&
    // 		this.utilsService.hasSessionTimePassed(this.sessionInfo.sessionTime, currentTime)
    // 	) {
    // 		this.joinButtonAvailable = true
    // 		rematchAtStart = true
    // 	} else {
    // 		this.joinButtonAvailable = false
    // 	}
    // }

    // public onClickCancelSession(): void {
    // 	if (!this.sessionInfo.partnerId || this.cancelConfirmState) {
    // 		this.cancelSessionService
    // 			.cancelSession(this.sessionInfo.externalId, SessionTileSource.CalendarTile)
    // 			.subscribe(() => {})
    // 	} else {
    // 		this.cancelConfirmState = true
    // 	}
    // }

    // public onClickConfirmCancelSession(): void {
    // 	this.cancelSessionService
    // 		.cancelSession(this.sessionInfo.externalId, SessionTileSource.CalendarTile)
    // 		.subscribe(() => {})
    // }

    // public onClickKeepSession() {
    // 	this.cancelConfirmState = false
    // }

    // public onClickSendSessionInfoToDynamicPanel(): void {
    // 	const stackItem: ContentStackItem = {
    // 		component: RpSessionInfoComponent,
    // 		context: { sessionTime: this.sessionInfo.sessionTime },
    // 		popIfCovered: true,
    // 		preserveStack: false,
    // 		showRefreshButton: false,
    // 	}
    // 	this.contentStackService.pushContent(stackItem)
    // }

    ngOnDestroy() {}
}
